import {generalRequest} from "@/lib/services/requests";

import {useInfiniteQuery} from "@tanstack/react-query";

export const useApiSearchAdminPolls = (args, config) => {
    return useInfiniteQuery({
        queryKey: ['admin', 'poll', 'search', args],
        queryFn: ({pageParam = 1}) => ((async (config = {}) => {
            return generalRequest.get(`/admin/polls`, config)
        })({...args, page: pageParam})),
        ...config
    })
}